import { render, staticRenderFns } from "./TuitionTutorial.vue?vue&type=template&id=1ccc75c6&scoped=true&"
import script from "./TuitionTutorial.vue?vue&type=script&lang=ts&"
export * from "./TuitionTutorial.vue?vue&type=script&lang=ts&"
import style0 from "./TuitionTutorial.vue?vue&type=style&index=0&id=1ccc75c6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccc75c6",
  null
  
)

export default component.exports